export const EXPORT_CHART_ICON_ID = 'export-chart-as-pdf-icon'

// Delay to allow Chart.js canvas redraw after layout changes

export const gridCharts = {
  sroiImpactPathways: 'sroi-impact-pathways',
  sroiCapitalImpact: 'sroi-capital-impact',
  sroiHeadcountPerStakeholder: 'sroi-headcount-per-stakeholder',
  sroiWellbeingStatistics: 'sroi-wellbeing-statistics',
  sroiSocialValueStakeholders: 'sroi-social-value-stakeholders',
  sroiImpactResidentialStatus: 'sroi-impact-residential-status',
  sroiImpactDisability: 'sroi-impact-disability',
  sroiImpactDeprivation: 'sroi-impact-deprivation',
  sroiSocialValueAge: 'sroi-social-value-age',
  sroiImpactByRegion: 'sroi-impact-by-region',
  sroiGenderGraph: 'sroi-gender-graph'
}

export const fullWidthCharts = {
  sroiMappingSdgs: 'sroi-mapping-sdgs',
  sroiMappingThemes: 'sroi-mapping-themes'
}

export const sectionIds = {
  sroiInfoPanels: 'sroi-info-panels',
  sroiFilters: 'sroi-filters',
  totalsSummaryPanels: 'totals-summary-panels'
}

export const pdfExportComponentKeys = {
  stakeholdersChart: 'stakeholders-chart-pdf',
  sroiInfoPanels: 'sroi-info-panels-export'
}

export const helpTexts = {
  investment: 'The total amount of investment that went into this project.',
  socialValue: 'The total amount of social value generated by this project.',
  activityHours: 'The total number of activity hours stakeholders partook in during this project.',
  stakeholders:
    'The total number of stakeholders involved in this project, and the sub-total number of various stakeholder types involved in this project.',
  filterReport: 'Filter to see the impact of this project on individual stakeholder types.',
  headcountAndPerStakeholderImpact:
    'See the headcount values of the stakeholder types involved in this project and their per capita impact values.',
  socialValueByStakeholders:
    'See the total impact on all stakeholders of various types (i.e., All players, or all community attendees) and use the slider to see this total impact broken down by pathway.',
  capitalImpact: {
    description: 'See how total social impact is broken down by types of capital:',
    sections: [
      {
        title: 'Social capital:',
        text: 'The networks, relationships, and trust that enable people and communities to work together effectively.'
      },
      {
        title: 'Human capital:',
        text: 'The skills, knowledge, health, and abilities of people that contribute to productivity and wellbeing.'
      },
      {
        title: 'Natural capital:',
        text: 'The stock of natural resources and ecosystems that provide essential goods and services.'
      }
    ]
  },
  impactByResidentialStatus: {
    description: 'See how total social impact is broken down by Residential Status:',
    sections: [
      {
        title: 'Locals:',
        text: "Al'Ula Residents."
      },
      {
        title: 'Nationals:',
        text: "Non-Al'Ula Saudi nationals."
      },
      {
        title: 'Internationals:',
        text: "International visitors to Al'Ula."
      }
    ]
  },
  impactByAgeGroup: {
    description: 'See how total social impact is broken down by age groups:',
    sections: [
      {
        title: 'Children:',
        text: 'Under 12'
      },
      {
        title: 'Teen:',
        text: '12-18'
      },
      {
        title: 'Youth:',
        text: '19-24'
      },
      {
        title: 'Adult:',
        text: '25-60'
      },
      {
        title: 'Old:',
        text: 'Over 60'
      }
    ]
  },
  impactByGender: 'See how total social impact is broken down by gender.',
  mappingOfImpactToSdgs: 'See how total social impact maps to UN Sustainable Development Goals (SDGs).',
  mappingOfImpactToVision2030:
    'See how total social impact maps to pillars of Saudi Arabia Vision 2030 and RCU social impact definition.',
  impactByPathway: {
    description: 'See how total social impact is broken down by types of capital:',
    sections: [
      {
        title: 'Wellbeing pathway:',
        text: "The process by which an activity influences people's pathway quality of life, including increased happiness, improved life satisfaction, reduced anxiety and improved sense of purpose towards life."
      },
      {
        title: 'Health pathway:',
        text: 'The process by which an activity affects physical and mental health outcomes, such as improved fitness, leading to reduced illness, and thus lower health costs.'
      },
      {
        title: 'Indirect financial pathway:',
        text: 'The process by which an activity leads to economic effects indirectly, such as increased employability and productivity, higher education attainment or revenue generation leading to higher public spending on education and health.'
      }
    ]
  }
}
